import axiosInstance from "config/AxiosConfig";
import { UserAssignScopeReq } from "domain/payload/request/user/UserAssignScopeReq";
import { UserClientConfigResp } from "domain/payload/response/user/UserClientConfigResp";
import { UserProjectConfigResp } from "domain/payload/response/user/UserProjectConfigResp";
import { UserDataScopeDetailResp } from "domain/payload/response/user/UserScopeDetailResp";

const UserDataScopeService = () => {
  const getScopeDetail = async (
    token: string,
    userId: string
  ): Promise<UserDataScopeDetailResp> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/user-data-scope/detail?id=${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Failed to fetch user scope';
    }
  };

  const assignScope = async (
    token: string,
    request: UserAssignScopeReq
  ): Promise<void> => {
    try {
      await axiosInstance.post(`/v1/legacy/cms/user-data-scope/assign`, request, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error: any) {
      throw error.response?.data?.message || 'Failed to assign scope';
    }
  };

  const getClients = async (token: string): Promise<UserClientConfigResp[]> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/user-data-scope/client-config`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Failed to fetch clients';
    }
  };

  const getProjects = async (token: string): Promise<UserProjectConfigResp[]> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/user-data-scope/project-config`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      return response.data.data;
    } catch (error: any) {
      throw error.response?.data?.message || 'Failed to fetch projects';
    }
  };

  return {
    getScopeDetail,
    assignScope,
    getClients,
    getProjects,
  };
};

export default UserDataScopeService;